import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
import * as userService from '../services/userService'
import * as transactionService from '../services/transactionService'
import "react-datetime/css/react-datetime.css";
import Currency from './sub_components/currency'
import printJS from 'print-js'
import Toast from './sub_components/toast';
import { BASE_IMAGE_PATH } from '../configs/api';
let printClickTimeout
class GameReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accounts: "",
            client_id: "",
            toastMsg: "",
            toastType: "",
            settleClient: 0,
            settleMaster: 0,
            showToast: false,
            showData: false,
            loader: false,
            userData: {},
            clientList: []
        };
    }
    componentDidMount() {
        let userData = localStorage.getItem("userAccData")
        userData = JSON.parse(userData)
        // let curDate = new Date().setHours(23,59,59,999);
        let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ accounts: userData.username, userData: userData, to: curDate, from: weekDate },
            () => {
                this.onUserList()
                this.onSettlementList()
            }
        )
    }
    componentWillUnmount(){
        clearTimeout(printClickTimeout)
    }
    async onUserList() {
        let user_list = await userService.getUsers()
        user_list = user_list.items
        this.setState({ clientList: [] },
            () => {
                this.setState({ clientList: user_list })
            }
        )
    }
    async onSettlementList() {
        const self = this;
        // let body = {
        //     "user_id": this.state.accounts,
        //     "client_id": "",
        //     "transaction_type": "settlement"
        // }
        let body = {
            "userId": this.state.accounts,
            "transactionType": "settlement"
        };
        body = this.clean(body);
        this.setState({ showData: false, loader: true })
        transactionService.postSettlementReport(body).then((res) => {
            if (res.isSuccess) {
                self.setState(
                    {
                        settleClient: 0,
                        settleMaster: 0,
                    }, () => {
                        let parent_id = this.state.userData.parentId
                        let user_id = this.state.accounts
                        let clientsettletotal = 0
                        let mastersettletotal = 0
                        let clientsettle = res.items.filter((data) => { return data.debitAccount !== parent_id && data.creditAccount !== parent_id })
                        let mastersettle = res.items.filter((data) => { return data.debitAccount === parent_id || data.creditAccount === parent_id })

                        for (let clt of clientsettle) {
                            if (clt.creditAccount === user_id) {
                                clientsettletotal += clt.amount
                            }
                            else if (clt.debitAccount === user_id) {
                                clientsettletotal -= clt.amount
                            }
                        }

                        for (let mas of mastersettle) {
                            if (mas.creditAccount === user_id) {
                                mastersettletotal += mas.amount
                            }
                            else if (mas.debitAccount === user_id) {
                                mastersettletotal -= mas.amount
                            }
                        }

                        self.setState({
                            settleClient: clientsettletotal,
                            settleMaster: mastersettletotal,
                            showData: true,
                            loader: false
                        })
                    }
                );
            } else {
                // this.props.notify(res.message, "error")
                this.setState({ settlement_balance_data: [], settlement_balance_search_data: [], showData: true, loader: false })
            }
        })

    }
    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    async onPDFDownload() {
        printClickTimeout = setTimeout(function () {
            printJS({
                printable: 'printJS-div',
                type: 'html',
                style: '@page { size: Letter;}',
                targetStyles: ['*']
            })
        }, 500)
    }

    resetForm() {
        // let curDate = new Date().setHours(23,59,59,999);
        // let curDate = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        // let weekDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0)
        this.setState({ showData: false })
    }
    showToast(msg, type) {
        let self = this
        this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
            setTimeout(() => {
                self.setState({ toastMsg: "", toastType: "", showToast: false })
            }, 3000);
        })
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })
    }
    render() {
        let plus_data = this.state.clientList.filter((clt) => { return clt.upLineBalance >= 0 })
        let minus_data = this.state.clientList.filter((clt) => { return clt.upLineBalance < 0 })

        let minus_total = 0
        let plus_total = 0

        for (let clt of plus_data) {
            plus_total += clt.upLineBalance
        }
        for (let clt of minus_data) {
            minus_total += clt.upLineBalance

        }
        let current_pnl = this.state.userData.pnl
        if (current_pnl >= 0) {
            plus_total += current_pnl
        } else {
            minus_total += current_pnl
        }

        if (this.state.settleClient >= 0) {
            plus_total += this.state.settleClient
        } else {
            minus_total += this.state.settleClient
        }

        if (this.state.settleMaster >= 0) {
            plus_total += this.state.settleMaster
        } else {
            minus_total += this.state.settleMaster
        }

        let master_pnl = -(this.state.userData.upLineBalance)
        if (master_pnl >= 0) {
            plus_total += master_pnl
        } else {
            minus_total += master_pnl
        }
        return (
            <div className="bethubs">
                <Header history = {this.props.history} />
                <div className="wrapper">
                    <div className="container-fluid container-padding-0">
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="main-box">
                                    <h5 className="text-blue">Balance Sheet</h5>
                                    {!this.state.showData && !!this.state.loader ? <div className={"ml-2 mt-2"}>Loading......</div> : null}
                                    {!!this.state.showData && <div>
                                        <div className="row">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-6 my-2">
                                                <div className="d-flex float-left">
                                                    {/* <div className="form-group mb-0 d-inline">
                                                        <input className="form-control" onChange={(e) => { this.onSearch(e) }} type="text" placeholder="Search" aria-label="Search" />
                                                    </div> */}
                                                    {/* <CSVLink
                                                        data={this.state.csv_json}
                                                        filename={"Bet History.csv"}
                                                        asyncOnClick={true}
                                                        className="d-none"
                                                        ref={this.csvLink}>
                                                    </CSVLink> */}
                                                    {/* <button className="btn btn-sm d-inline csv-icon p-0" title="Export Data" onClick={(e) => this.onDownload(e)} disabled={plus_data.length > 0 || minus_data.length > 0 ? false : true}><img alt="" src={BASE_IMAGE_PATH + "/aimg/csv-icon.svg"}></img></button> */}
                                                    <div style={{ display: "none" }}>
                                                        <div id="printJS-div">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-2 ">
                                                                    <div className="sports-tabel table-responsive">
                                                                        <table className={plus_data.length > 0 ? "table table-bordered tableprofit table-sm addpadding w-100" : "table table-responsive table-bordered tableprofit table-sm addpadding w-100 responsivetbl"}>
                                                                            <thead>
                                                                                <tr className="tbg">
                                                                                    <th className="font-weight-bold " colSpan="5">Creditors Account</th>
                                                                                </tr>
                                                                                <tr className="headings plusacc">
                                                                                    <th className="font-weight-bold">Name</th>
                                                                                    <th className="font-weight-bold text-right">Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {!!plus_data && plus_data.map((client, i) => {
                                                                                    return (<>
                                                                                        <tr>
                                                                                            <td><span className={client.role === "SuperMaster" || client.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + client.role + "-icon.svg"} alt="" /></span>{!!client.username ? client.username : "-"}</td>
                                                                                            <td className="text-right">{!!client.upLineBalance ? <Currency key={"game_plus_" + i} className="fbold" amount={client.upLineBalance} showColor={true} /> : "0.00"}</td>
                                                                                        </tr>
                                                                                    </>)
                                                                                })}
                                                                                {this.state.settleClient >= 0 &&
                                                                                    <tr>
                                                                                        <td>Cash</td>
                                                                                        <td className="text-right"> <Currency key={"game_plus_settle_client"} className="fbold" amount={this.state.settleClient} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                {current_pnl >= 0 &&
                                                                                    <tr>
                                                                                        <td>Profit/Loss</td>
                                                                                        <td className="text-right"> <Currency key={"game_plus_current"} className="fbold" amount={current_pnl} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                {this.state.settleMaster >= 0 &&
                                                                                    <tr>
                                                                                        <td>Parent ( Cash )</td>
                                                                                        <td className="text-right"> <Currency key={"game_plus_settle_master"} className="fbold" amount={this.state.settleMaster} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                {master_pnl >= 0 &&
                                                                                    <tr>
                                                                                        <td>Parent ( Up Line )</td>
                                                                                        <td className="text-right"> <Currency key={"game_plus_master"} className="fbold" amount={master_pnl} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                <tr className="tbg">
                                                                                    <td className="text-left font-weight-bold" >General Total </td>
                                                                                    <td className="text-right">{!!plus_total ? parseFloat(plus_total).toFixed(2) : "-"}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-2 ">
                                                                    <div className="sports-tabel table-responsive">
                                                                        <table className={minus_data.length > 0 ? "table table-bordered tableprofit table-sm addpadding w-100" : "table table-responsive table-bordered tableprofit table-sm addpadding w-100 responsivetbl"}>
                                                                            <thead>
                                                                                <tr className="tbr">
                                                                                    <th className="font-weight-bold text-white" colSpan="5">Debtors Account</th>
                                                                                </tr>
                                                                                <tr className="headings plusacc">
                                                                                    <th className="font-weight-bold">Name</th>
                                                                                    <th className="font-weight-bold text-right">Amount</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {!!minus_data && minus_data.map((client, i) => {
                                                                                    return (<>
                                                                                        <tr>
                                                                                            <td><span className={client.role === "SuperMaster" || client.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + client.role + "-icon.svg"} alt="" /></span>{!!client.username ? client.username : "-"}</td>
                                                                                            <td className="text-right">{!!client.upLineBalance ? <Currency key={"game_minus_" + i} className="fbold" amount={client.upLineBalance} showColor={true} /> : "0.00"}</td>
                                                                                        </tr>
                                                                                    </>)
                                                                                })}

                                                                                {this.state.settleClient < 0 &&
                                                                                    <tr>
                                                                                        <td>Cash</td>
                                                                                        <td className="text-right"> <Currency key={"game_minus_settle_client"} className="fbold" amount={this.state.settleClient} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                {current_pnl < 0 &&
                                                                                    <tr>
                                                                                        <td>Profit/Loss</td>
                                                                                        <td className="text-right"> <Currency key={"game_minus_current"} className="fbold" amount={current_pnl} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                {this.state.settleMaster < 0 &&
                                                                                    <tr>
                                                                                        <td>Parent ( Cash )</td>
                                                                                        <td className="text-right"> <Currency key={"game_minus_settle_master"} className="fbold" amount={this.state.settleMaster} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                {master_pnl < 0 &&
                                                                                    <tr>
                                                                                        <td>Parent ( Up Line )</td>
                                                                                        <td className="text-right"> <Currency key={"game_minus_master"} className="fbold" amount={master_pnl} showColor={true} /> </td>
                                                                                    </tr>
                                                                                }
                                                                                <tr className="tbr">
                                                                                    <td className="font-weight-bold">General Total </td>
                                                                                    <td className="text-right">{!!minus_total ? parseFloat(minus_total).toFixed(2) : "-"}</td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button className="btn btn-sm pdf-icon d-inline p-0" title="Export Data" onClick={(e) => this.onPDFDownload(e)} disabled={plus_data.length > 0 || minus_data.length > 0 ? false : true}>
                                                        <img alt="" src={BASE_IMAGE_PATH + "/aimg/pdf-icon.svg"}></img>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-2 ">
                                                <div className="sports-tabel table-responsive">
                                                    <table className={plus_data.length > 0 ? "table table-bordered tableprofit table-sm addpadding w-100" : "table table-responsive table-bordered tableprofit table-sm addpadding w-100 responsivetbl"}>
                                                        <thead>
                                                            <tr className="tbg">
                                                                <th className="font-weight-bold " colSpan="5">Creditors Account</th>
                                                            </tr>
                                                            <tr className="headings plusacc">
                                                                {/* <th className="font-weight-bold">Sr.No</th> */}
                                                                <th className="font-weight-bold">Name</th>
                                                                <th className="font-weight-bold text-right">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!!plus_data && plus_data.map((client, i) => {

                                                                // plus_total += client.upLineBalance
                                                                // plus_index += 1
                                                                return (<>
                                                                    <tr>
                                                                        {/* <td>{plus_index}</td> */}
                                                                        <td><span className={client.role === "SuperMaster" || client.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + client.role + "-icon.svg"} alt="" /></span>{!!client.username ? client.username : "-"}</td>
                                                                        <td className="text-right">{!!client.upLineBalance ? <Currency key={"game_plus_" + i} className="fbold" amount={client.upLineBalance} showColor={true} /> : "0.00"}</td>
                                                                    </tr>
                                                                </>)
                                                            })}
                                                            {this.state.settleClient >= 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Cash</td>
                                                                    <td className="text-right"> <Currency key={"game_plus_settle_client"} className="fbold" amount={this.state.settleClient} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            {current_pnl >= 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Profit/Loss</td>
                                                                    <td className="text-right"> <Currency key={"game_plus_current"} className="fbold" amount={current_pnl} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            {this.state.settleMaster >= 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Parent ( Cash )</td>
                                                                    <td className="text-right"> <Currency key={"game_plus_settle_master"} className="fbold" amount={this.state.settleMaster} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            {master_pnl >= 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Parent ( Up Line )</td>
                                                                    <td className="text-right"> <Currency key={"game_plus_master"} className="fbold" amount={master_pnl} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            <tr className="tbg">
                                                                <td className="text-left font-weight-bold" >General Total </td>
                                                                <td className="text-right">{!!plus_total ? parseFloat(plus_total).toFixed(2) : "-"}</td>
                                                            </tr>
                                                            {/* {(Math.round(Math.abs(minus_total), 2)) > (Math.round(Math.abs(plus_total), 2)) ?
                                                                <>
                                                                    {!!this.state.userData && !!this.state.userData.sharingDetail && this.state.userData.sharingDetail.sports ?
                                                                        <tr>
                                                                            <td>{plus_index + 1}</td>
                                                                            <td>Up Level</td>
                                                                            <td className="text-right"> <Currency key={"game_plus_uplvl"} className="fbold" amount={Math.abs(plus_total + minus_total)} showColor={true} /> </td>
                                                                        </tr>
                                                                        : null
                                                                    }
                                                                    <tr className="tbg">
                                                                        <td className="text-left font-weight-bold" colSpan={2}>General Total</td>
                                                                        <td className="text-right">{!!minus_total ? <Currency key={"game_plus_totm"} className="fbold" amount={Math.abs(minus_total)} showColor={false} /> : "-"}</td>
                                                                    </tr>
                                                                </> :
                                                                <tr className="tbg">
                                                                    <td className="text-left font-weight-bold" colSpan={2}>General Total</td>
                                                                    <td className="text-right">{!!plus_total ? <Currency key={"game_plus_totp"} className="fbold" amount={plus_total} showColor={false} /> : "-"}</td>
                                                                </tr>
                                                            } */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-12 col-md-12 col-lg-6 mb-2 ">
                                                <div className="sports-tabel table-responsive">
                                                    <table className={minus_data.length > 0 ? "table table-bordered tableprofit table-sm addpadding w-100" : "table table-responsive table-bordered tableprofit table-sm addpadding w-100 responsivetbl"}>
                                                        <thead>
                                                            <tr className="tbr">
                                                                <th className="font-weight-bold text-white" colSpan="5">Debtors Account</th>
                                                            </tr>
                                                            <tr className="headings plusacc">
                                                                {/* <th className="font-weight-bold">Sr.No</th> */}
                                                                <th className="font-weight-bold">Name</th>
                                                                <th className="font-weight-bold text-right">Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!!minus_data && minus_data.map((client, i) => {
                                                                // minus_index += 1
                                                                return (<>
                                                                    <tr>
                                                                        {/* <td>{minus_index}</td> */}
                                                                        <td><span className={client.role === "SuperMaster" || client.role === "SubSuperMaster" ? "client-icon-sm" : "client-icon"}><img src={BASE_IMAGE_PATH + "/aimg/" + client.role + "-icon.svg"} alt="" /></span>{!!client.username ? client.username : "-"}</td>
                                                                        <td className="text-right">{!!client.upLineBalance ? <Currency key={"game_minus_" + i} className="fbold" amount={client.upLineBalance} showColor={true} /> : "0.00"}</td>
                                                                    </tr>
                                                                </>)
                                                            })}

                                                            {this.state.settleClient < 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Cash</td>
                                                                    <td className="text-right"> <Currency key={"game_minus_settle_client"} className="fbold" amount={this.state.settleClient} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            {current_pnl < 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Profit/Loss</td>
                                                                    <td className="text-right"> <Currency key={"game_minus_current"} className="fbold" amount={current_pnl} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            {this.state.settleMaster < 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Parent ( Cash )</td>
                                                                    <td className="text-right"> <Currency key={"game_minus_settle_master"} className="fbold" amount={this.state.settleMaster} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            {master_pnl < 0 &&
                                                                <tr>
                                                                    {/* <td>{plus_index + 1}</td> */}
                                                                    <td>Parent ( Up Line )</td>
                                                                    <td className="text-right"> <Currency key={"game_minus_master"} className="fbold" amount={master_pnl} showColor={true} /> </td>
                                                                </tr>
                                                            }
                                                            <tr className="tbr">
                                                                <td className="font-weight-bold">General Total </td>
                                                                <td className="text-right">{!!minus_total ? parseFloat(minus_total).toFixed(2) : "-"}</td>
                                                            </tr>
                                                            {/* {(Math.round(Math.abs(minus_total), 2)) < (Math.round(Math.abs(plus_total), 2)) ? <>
                                                                {!!this.state.userData && !!this.state.userData.sharingDetail && this.state.userData.sharingDetail.sports ?
                                                                    <tr>
                                                                        <td>{minus_index + 1}</td>
                                                                        <td>Up Level</td>
                                                                        <td className="text-right"> <Currency key={"game_minus_uplvl"} className="fbold" amount={-(plus_total + minus_total)} showColor={true} /> </td>
                                                                    </tr>
                                                                    : null
                                                                }
                                                                <tr className="tbr">
                                                                    <td className="font-weight-bold" colSpan={2}>General Total</td>
                                                                    <td className="text-right">{!!plus_total ? <Currency key={"game_minus_totm"} className="fbold" amount={(-(plus_total))} showColor={false} /> : "-"}</td>
                                                                </tr>
                                                            </> :
                                                                <tr className="tbr">
                                                                    <td className="font-weight-bold" colSpan={2}>General Total</td>
                                                                    <td className="text-right">{!!minus_total ? <Currency key={"game_minus_totp"} className="fbold" amount={minus_total} showColor={false} /> : "-"}</td>
                                                                </tr>
                                                            } */}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(GameReports);